import { HttpErrorResponse } from '@angular/common/http';
import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { MatFormField, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-restore-password',
  templateUrl: './restore-password.component.html',
  styleUrls: ['./restore-password.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FormsModule, ReactiveFormsModule, MatFormField, MatInput, MatError, MatButton],
})
export class RestorePasswordComponent implements OnInit {
  protected readonly page_title = inject(ActivatedRoute).snapshot.title;

  form: FormGroup;
  token: string = '';
  token_provided: boolean = false;

  private fb = inject(FormBuilder);
  private router = inject(Router);
  private api = inject(ApiService);
  private snack = inject(MatSnackBar);
  private activatedRoute = inject(ActivatedRoute);

  constructor() {
    this.form = this.fb.group(
      {
        token: ['', Validators.compose([Validators.required])],
        password: ['', Validators.compose([Validators.required, Validators.minLength(4)])],
        repeat_password: ['', Validators.compose([Validators.required, Validators.minLength(4)])],
      },
      { validator: this.checkPasswords }
    );
  }

  ngOnInit(): void {
    this.token = this.activatedRoute.snapshot.queryParamMap.get('token')!;
    this.token_provided = this.token ? true : false;
    this.form.patchValue({ token: this.token });
  }

  submit() {
    this.api.resetPassword(this.form.value).subscribe(
      () => {
        this.snack.open('Se ha actualizado su contraseña correctamente', 'Ok', { duration: 3000 });
        this.router.navigate(['/auth/login']);
      },
      (error: HttpErrorResponse) => {
        if (error.status == 401) {
          this.snack.open('El correo y/o la contraseña son incorrectos', 'Ok', { duration: 3000 });
        } else {
          this.snack.open(error.error.message, 'Ok', { duration: 3000 });
        }
      }
    );
  }

  checkPasswords(group: FormGroup) {
    const pass = group.controls.password.value;
    const confirmPass = group.controls.repeat_password.value;
    return pass === confirmPass ? null : { notSame: true };
  }
}
